module.exports = __webpack_public_path__ + "img/22_66.37064b7b.png";